import { render, staticRenderFns } from "./AccountClass.vue?vue&type=template&id=57068bf8&scoped=true&"
import script from "./AccountClass.vue?vue&type=script&lang=js&"
export * from "./AccountClass.vue?vue&type=script&lang=js&"
import style0 from "./AccountClass.vue?vue&type=style&index=0&id=57068bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57068bf8",
  null
  
)

export default component.exports